/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, Status, arrayFrom, getId, openWindow } from '../twd'
import formatBook from './format-book'
import GridHeader from './grid-header'
import { MarketCheck } from './market-check'

export default ({Last, invType, rows, sort, status, selection, onSelect}) => {

    if (status!==Status.LOADED && rows.length===0) {
        return null
    }

    let isNone = invType==='-'
    let isMuni = invType==='M'
    let isCorp = invType==='C'
    let isCd = invType==='S'
    let isTreasury = invType==='T'
    let isAgency = invType==='A'
    let showRating = !isNone && !isCd && !isTreasury
    let showMarket = !isNone && (isMuni || isCorp || isAgency)

    return <div className="table-responsive">
    <table
        data-name="offerings-table"
        style={{borderTop: '2px solid #e4e4e4'}}
        className="table table-hover table-striped align-top"
    >
    <GridHeader Last={Last} invType={invType} sort={sort} rows={rows} selection={selection} onSelect={onSelect} />
    <tbody>{
        rows && rows.map( (r,i) => {
            return <tr
                data-name="offerings-row"
                key={i}>
            <td className="text-center"
                style={{width:'25px', maxWidth:'25px', verticalAlign:'middle'}}>
                {formatCheckbox({row:r, selection, onSelect})}
            </td>
            <td className="text-right">
                {askItem(fmt.qty(r.askQuantity))}
                <br/>
                {bidItem(fmt.qty(r.bidQuantity))}
            </td>
            <td className="text-right">
                {askItem(fmt.qty(r.askQtyMin))}
                <br/>
                {bidItem(fmt.qty(r.bidQtyMin))}</td>
            <td className="text-right">
                {askItem(fmt.qty(r.askQtyIncr))}
                <br/>
                {bidItem(fmt.qty(r.bidQtyIncr))}
            </td>
            {isMuni && <td className="text-center">{r.holdState}</td>}
            <td style={{maxWidth:'250px'}}>
                {fmt.issuer({
                    issuer:r.holdIssue,
                    cusip:r.holdCusip,
                    offers: r,
                    showTradeHistory: 'Y',
                    from:'offerings'
                })}
                <br/>
                <label className="label-small"
                    style={{whiteSpace:'normal'}}
                    dangerouslySetInnerHTML={{__html:fmt.warningText(r.holdWarningText)}}
                ></label>
            </td>
            {isCd && <td>{r.holdFdicNum}</td>}
            <td className="text-right">{formatCoupon(r)}</td>
            {isCd && <td>{r.couponPaymentFreq}</td>}
            {isCd && <td>{formatCouponType(r)}</td>}
            <td className="text-right">
                {r.holdMaturity}
            </td>
            <td className="text-right">
                {askItem(fmt.price(r.askPrice))}
                <br/>
                {bidItem(fmt.price(r.bidPrice))}
            </td>
            <td className="text-center">
                {formatBook(r)}</td>
            <td className="text-right">
                {askItem(fmt.ytw(r.askYieldmat))}
                <br/>
                {bidItem(fmt.ytw(r.bidYieldmat))}
            </td>
            <td className="text-right">
                {askItem(formatYield(r.askYield, r.askYtwInd))}
                <br/>
                {bidItem(formatYield(r.bidYield, r.bidYtwInd))}
            </td>
            {showRating && <td style={{whiteSpace:'nowrap'}}>{pdfIcon(r)} {r.moodyRating}</td>}
            {showRating && <td>{r.spRating}</td>}
            {showMarket && <td style={{maxWidth:'120px'}}><MarketCheck {...r}/></td>}
            <td className="text-center" style={{maxWidth:'55px'}}>
                {formatOrder(r)}
            </td>

            </tr>
        })
    }</tbody>
    <tfoot>
        <tr><td colSpan="18">
            (c) Yield to Call,
            (dis) Discount Yield,
            (f) Called in Full,
            (n) Floating/Variable Rate,
            (p) Yield to Par Call,
            (r) Pre-Refund,
            (t) Put,
            (w) Yield to Middle Call
        </td></tr>
    </tfoot>
    </table>
    </div>
}

const askItem = (txt) => <span style={{color:'green'}}>{txt}</span>
const bidItem = (txt) => <span style={{color:'red'}}>{txt}</span>


const formatCheckbox = ({row, selection, onSelect}) => {
    let id = getId()
    return <div className="checkbox">
    <input
        data-name="offerings-select"
        type="checkbox"
        id={id}
        checked={arrayFrom(selection).indexOf(row)>=0}
        onChange={() => onSelect(row)}
    />
    <label htmlFor={id}></label>
    </div>
}

const formatCoupon = ({holdCoupon, holdCouponTypeCode, holdCouponFixedToFloat}) => {
    let isFLT = holdCouponTypeCode==='E'
    let isF2F = holdCouponFixedToFloat==='Y'

    if (isFLT) {
        return !isF2F
            ? 'FLT'
            : <React.Fragment>{fmt.cpn(holdCoupon)}<br/>F2F</React.Fragment>
    }
    return fmt.cpn(holdCoupon)
}

const formatCouponType = (r) => {
    let c = r.holdCouponTypeCode
    if (c==='B') return 'Zero'
    if (['A','C','F','K','N'].indexOf(c)>=0) return 'Fixed, Non-Zero'
    if (r.holdCouponFixedToFloat==='Y') return 'Fixed to Float, Fixed'
    if (arrayFrom(r.holdStepSchedule).length>1) return 'Multi-Step'
    if (['D','I','G'].indexOf(c)>=0) return 'Floating'
    return '-'
}

const formatYield = (val, ind) => {
    let x = Number.parseFloat(val)
    if (isNaN(x)) return fmt.empty()

    let y = fmt.ytw(x)
    if (!ind) return y
    ind = ind.toLowerCase()
    if (['c','dis','f','n','p','r','t','w'].indexOf(ind)<0) return y

    return <React.Fragment>{y} ({ind})</React.Fragment>
}

const formatOrder = (r) => {
    if (r.allowTrading===false) return fmt.orderPhone()

    return <React.Fragment>
        <div>
        {r.askQuantity && fmt.buy({cusip:r.holdCusip, from:'offerings', extraClassName:'vertical-offset-xxs'})}
        {!r.askQuantity && <br/> }
        </div>
        <div>
        {r.bidQuantity && fmt.sell({cusip:r.holdCusip, from:'offerings'})}
        </div>
    </React.Fragment>
}


const pdfIcon =  ({moodyRating, holdCusip:cusip}) => {
    if (!moodyRating) return null

    return <a href='#'
        data-name="offerings-pdf-icon"
        style={{cursor:'pointer'}}
        onClick={() => {
            let url = '/esb/moodysreport/getBondReport?cusip=' + cusip
            openWindow(url)
        }}
    ><i className="material-icons" aria-hidden="true">picture_as_pdf</i></a>
}


// WEBPACK FOOTER //
// ./src/offerings/grid.js